jQuery(document).ready(function($) { 

		 ///// MENU MOBILE /////
 //////////////////////////

	 var menu_mobile = $('#primary-menu').clone();
	 var accueil_href = $('.site-title a').attr('href');
	 //var menu_rdv_en_ligne = $('#primary-menu li:last-child a').clone().addClass('btn_mobile_rdv btn_bordure');
	 //$("#masthead").prepend(menu_rdv_en_ligne);
	// menu_mobile.prepend('<li><a href="'+accueil_href+'">Accueil</a></li>');

	  menu_mobile.slicknav({
	  	prependTo:"#masthead",
	    duration:300,
	    beforeOpen:move_body,
	    beforeClose:move_body,
	    allowParentLinks:true,
	    nestedParentLinks:true, // tester si c'est ok sinon false pour séparer le lien parent du s-menu
	  });

	  function move_body(){

	    if($('.slicknav_btn').hasClass('slicknav_open')){
	      $('body').addClass('move_to_right');
	    }else{
	      $('body').removeClass('move_to_right');
	    }
	  }
//// FIN MENU MOBILE //////



	// OWL CAROUSEL HOME
	 var owl_home_page = $("#home_sticky");

 	if ( $( owl_home_page).length ) {
	  owl_home_page.owlCarousel({
	  	 loop:true,
	  	 autoplay:true,
	  	 autoplayTimeout:5500,
	  	 autoplaySpeed:1500,
         navSpeed:1300,
         smartSpeed:1300,
         fluidSpeed:1300,
    	 margin:0,
   		 nav:false,
   		 items:1,
 		   // animateIn: 'fadeInDown',
      //    animateOut: 'slideOutLeft'
	  });
   }
	///// ////// //// FIN DIAPORAMA TOP HOME ///// /////// ///// 



	var liste_btn = $(".nav_slide_generation");

	// $( ".nav_slide_generation a" ).click(function(event) {
	//  event.preventDefault();
	// });

	 // OWL GENERATION
	 var owl_generation = $("#slide_generation");

 	if ( $( owl_generation).length ) {

	  owl_generation.owlCarousel({
	  	 loop:false,
	  	 autoplay:true,
	  	 autoplayHoverPause:true,
	  	 autoplayTimeout:7500,
	  	 autoplaySpeed:1500,
         navSpeed:1300,
         smartSpeed:1300,
         fluidSpeed:1300,
   		 nav:false,
   		 items:1,
   		 margin:380,
   		 URLhashListener:true,
 		  animateIn: 'slideInRight',
          animateOut: 'slideOutRight'
	  });

	  owl_generation.on('changed.owl.carousel', function(event) {
   		 var item      = event.item.index;
   		 liste_btn.find('li').removeClass('active');
   		 liste_btn.find('li').eq(item).addClass('active');
	});


   }




	// OWL TEMOIGNAGES
	 var owl_temoignage = $("#temoignages");

 	if ( $( owl_temoignage).length ) {

	  owl_temoignage.owlCarousel({
	  	 loop:true,
	  	 autoplay:true,
	  	 autoplayTimeout:5500,
	  	 autoplaySpeed:1500,
         navSpeed:1300,
         smartSpeed:1300,
         fluidSpeed:1300,
   		 nav:true,
   		 items:2,
   		 margin:100,
   		 responsive : {
		    // breakpoint from 0 up
		    0 : {
		        items : 1
		    },
		    // breakpoint from 480 up
		    750 : {
		        items : 2
		    }
		},
   		 navText:["<span class='icon-fleche_gauche'></span>","<span class='icon-fleche_droite'></span>"]
   		 
 		   // animateIn: 'fadeInDown',
      //    animateOut: 'slideOutLeft'
	  });
   }

	///// ////// //// FIN DIAPORAMA TOP HOME ///// /////// ///// 


	/// OWL REALISATIONS 
	var slide_realisation = $("#slide-realisation");

 	if ( $(slide_realisation).length ) {

	  slide_realisation.owlCarousel({
	  	 loop:true,
	  	 autoplay:true,
	  	 autoplayTimeout:5500,
	  	 autoplaySpeed:1500,
         navSpeed:1300,
         smartSpeed:1300,
         fluidSpeed:1300,
   		 nav:true,
   		 items:1,
   		 margin:100,
   		 navText:["<span class='icon-fleche_gauche'></span>","<span class='icon-fleche_droite'></span>"]
   		 
 		   // animateIn: 'fadeInDown',
      //    animateOut: 'slideOutLeft'
	  });
   }

	/// FIN OWL REALISATIONS 


	//	WOW EFFECT //
	  var wow = new WOW(
	    {
	      boxClass:     'wow',      // animated element css class (default is wow)
	      animateClass: 'animated', // animation css class (default is animated)
	      offset:       0,          // distance to the element when triggering the animation (default is 0)
	      mobile:       false,       // trigger animations on mobile devices (default is true)
	      live:         true,       // act on asynchronously loaded content (default is true)
	      callback:     function(box) {
	        // the callback is fired every time an animation is started
	        // the argument that is passed in is the DOM node being animated
	      },
	      scrollContainer: null // optional scroll container selector, otherwise use window
	    }
	  );
	 wow.init();
  // WOW EFFECT //



});